import { CategorieDto } from "@resources/resources";
import { Router, ActivatedRoute } from "@angular/router";
import { Component, Input } from "@angular/core";

@Component({
  selector: 'categorie',
  templateUrl: './categorie.component.html',
  host: { 'class': 'categorie' }
})
export class CategorieComponent {

  @Input() categorie: CategorieDto;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
  }

  goToArticlesPage() {
    this.router.navigate(['../categorie', this.categorie.id], { relativeTo: this.activatedRoute });
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-categories/categorie/categorie.component.ts